__turbopack_context__.v({
  "fadeInOut": "LogoCloud-module-scss-module__aZ0KVW__fadeInOut",
  "logo": "LogoCloud-module-scss-module__aZ0KVW__logo",
});
